import React, { CSSProperties, useEffect, useMemo, useState } from "react";

import { Button, Checkbox, Divider, Icon, Modal } from "semantic-ui-react";

import { useIntl } from "react-intl";

// Common
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import ModConfirmCNMI from "react-lib/apps/common/cnmi/ModConfirm";
import ModInfo from "react-lib/apps/common/ModInfo";
import SnackMessage from "react-lib/apps/common/SnackMessage";

// UX
import CardSettingDivisionUX from "./CardSettingDivisionUX";
import ModSelectDivision from "./ModSelectDivision";
import ReactTable, { CellInfo, RowInfo } from "react-table-6";

import CONFIG from "config/config";

// Types
type CardSettingDivisionProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => any) => any;
  // data
  organizationFilter?: boolean;
  profileDivision?: {
    data: Record<string, any>[];
    raw: Record<string, any>[];
  };
  tableHeaders?: string;
  tableKeys?: string;
  settingsUser?: Record<string, any> | null;
  // CommonInterface
  buttonLoadCheck?: Record<string, any>;
  errorMessage?: Record<string, any>;
  // options
  divisionOptions?: Record<string, any>[];
};

// styles
const styles = {
  title: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    marginTop: "5px",
  } as CSSProperties,
  header: {
    backgroundColor: "#c6ebf3",
    fontSize: "1.2rem",
    padding: "15px",
  } as CSSProperties,
};

// Const
const CARD_SETTING_DIVIDION = "CardSettingDivision";

const CardSettingDivision = (props: CardSettingDivisionProps) => {
  const intl = useIntl();

  const [openDivision, setOpenDivision] = useState<boolean>(false);
  const [openAddExtra, setOpenAddExtra] = useState<boolean>(false);
  const [modConfirmDelete, setModConfirmDelete] = useState<Record<string, any> | null>(null);
  const [modInfo, setModInfo] = useState<{
    color: "green" | "yellow";
    msg: string;
  } | null>(null);

  const [indexDivision, setIndexDivision] = useState<number>();
  const [selectedExtra, setSelectedExtra] = useState<string[]>([]);
  const [divisionsNotInclude, setDivisionsNotInclude] = useState<Record<string, any>[]>([]);

  // const [divisionTypeName, setDivisionTypeName] = useState<any[]>([]);
  const [dataScreen, setDataScreen] = useState<any[]>([]);
  const [selectedSettingDivisionsHasUser, setSelectedSettingDivisionsHasUser] = useState<{
    id?: number;
    name?: string;
  }>({});

  useEffect(() => {
    props.onEvent({ message: "SettingDivision", params: {} });

    return () => {
      props.setProp(`errorMessage.${CARD_SETTING_DIVIDION}`, {
        error: null,
      });
    };
  }, []);

  useEffect(() => {
    const divisionHasUser = props.profileDivision?.data.map((item: any) => item.division.id);
    const divisions = (props.divisionOptions || []).filter(
      (item: any) => !divisionHasUser?.includes(item.value)
    );

    setDivisionsNotInclude(divisions);
  }, [props.divisionOptions, props.profileDivision]);

  useEffect(() => {
    let data = props.profileDivision?.data?.find(
      (data: any) => data.id === selectedSettingDivisionsHasUser?.id
    );

    const filteredAdminNameList = Object.keys(ADMIN_NAME_LIST).filter((key) => {
      const hiddenTabs: string[] = CONFIG.V3_HIDDEN_TAB_LIST || [];

      return !hiddenTabs.includes(key);
    });

    let prepare = filteredAdminNameList.map((name) => ({
      menuName: name,
      isActive: !!data?.extra?.adminMenuList?.includes(name),
    }));
    setDataScreen(prepare);

  }, [selectedSettingDivisionsHasUser?.id, props.profileDivision]);

  const titleAddDivision = useMemo(
    () => (props.organizationFilter ? intl.formatMessage({ id: "key871" }) : "เพิ่มแผนก"),
    [props.organizationFilter]
  );

  const dataDivision = useMemo(() => {
    const data = props.profileDivision?.data || [];

    return data.map((item: any, index: number) => {
      const useRights: string[] = item.extra?.useRights || [];

      return {
        ...item,
        activeDiv: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Checkbox
              checked={!!item.extra?.is_Active}
              onChange={(e: any, v: any) => {
                props.setProp(`profileDivision.data.${index}.extra.is_Active`, v.checked);
                if (!v.checked && selectedSettingDivisionsHasUser?.id === item.id) {
                  setSelectedSettingDivisionsHasUser({});
                }
              }}
            />
          </div>
        ),
        code: item.division.code,
        delete: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Icon
              color="red"
              name="trash alternate"
              link
              onClick={(e) => {
                e.stopPropagation()

                setModConfirmDelete(item);
              }}
            />
          </div>
        ),
        name: item.division.name,
        type_label: item.division.type_label,
        extraDiv: (
          <div style={{ display: "flex" }}>
            <div> {useRights.join(", ")}</div>
            <div style={{ flex: "1" }}> </div>
            <Button
              color="yellow"
              icon="edit"
              size="mini"
              style={{ height: "fit-content" }}
              onClick={() => {
                setOpenAddExtra(true);
                setIndexDivision(index);
                setSelectedExtra(item.extra?.useRights || []);
              }}
            />
          </div>
        ),
      };
    });
  }, [props.profileDivision]);

  // Hanler
  const handleGetTdProps = (state: any, rowInfo?: RowInfo, column?: undefined, instance?: any) => ({
    style: {
      paddingLeft: "1rem",
    },
  });

  const handleGetTrProps = (state: any, rowInfo?: RowInfo, column?: undefined, instance?: any) => ({
    style: {
      ...(rowInfo?.original?.extra.is_Active && { cursor: "pointer" }),
    },
    className:
      rowInfo?.original?.id && rowInfo?.original?.id === selectedSettingDivisionsHasUser?.id
        ? "blueSelectedRow"
        : "",
    onClick: () => {
      console.log("A Td Element was clicked! rowInfo: ", rowInfo);
      if (rowInfo?.original?.extra.is_Active) {
        if (selectedSettingDivisionsHasUser?.id === rowInfo?.original?.id) {
          setSelectedSettingDivisionsHasUser({});
        } else {
          setSelectedSettingDivisionsHasUser({
            id: rowInfo?.original.id,
            name: rowInfo?.original?.name,
          });
        }
      }
    },
  });

  const handleSave = () => {
    props.onEvent({
      message: "SettingDivision",
      params: {
        action: "SAVE",
        id: props.settingsUser?.id,
        buttonLoadKey: `${CARD_SETTING_DIVIDION}_SAVE`,
        card: CARD_SETTING_DIVIDION,
        onSuccess: () => {
          setModInfo({ color: "green", msg: "บันทึกข้อมูลสำเร็จ" });
        },
      },
    });
  };

  const handleSelect = (divisions: any[]) => {
    props.onEvent({
      message: "SettingDivision",
      params: {
        action: "ADD_DIVISION",
        id: props.settingsUser?.id,
        card: CARD_SETTING_DIVIDION,
        selectedDivision: divisions,
      },
    });

    setOpenDivision(false);
  };

  const handleChangeRight = (e: any, v: any) => {
    let useRights = selectedExtra;

    if (v.checked === false) {
      useRights = useRights.filter((value: any) => value !== v.name);
    } else if (v.checked === true) {
      useRights.push(v.name);
    }

    setSelectedExtra([...useRights]);
  };

  const handleSaveRight = () => {
    if (indexDivision === undefined) {
      return;
    }

    const { extra } = props.profileDivision?.data[indexDivision] || {};

    extra.useRights = selectedExtra;

    props.setProp(`profileDivision.data.${indexDivision}.extra`, { ...extra });

    setOpenAddExtra(false);
  };

  const handleCancel = () => {
    props.setProp("profileDivision", {
      data: JSON.parse(JSON.stringify(props.profileDivision?.raw || [])),
      raw: props.profileDivision?.raw || [],
    });
  };

  const handleCloseModConfirmDelete = () => {
    setModConfirmDelete(null);

    props.setProp(`buttonLoadCheck.${CARD_SETTING_DIVIDION}_DELETE`, null);
  };

  const handleConfirmDelete = () => {
    props.onEvent({
      message: "SettingDivision",
      params: {
        action: "DELETE_DIVISION",
        buttonLoadKey: `${CARD_SETTING_DIVIDION}_DELETE`,
        card: CARD_SETTING_DIVIDION,
        data: modConfirmDelete,
        onSuccess: handleCloseModConfirmDelete,
      },
    });
  };

  const handleCloseModInfo = () => {
    setModInfo(null);
  };

  const handleOpenDivision = () => {
    setOpenDivision(true);
  };

  // #console.log("CardSettingDivision", props);

  const adminScreenColumns = [
    {
      Header: "ชื่อเมนูใน Admin",
      accessor: "menuName", // String-based value accessors!
    },
    {
      Header: "Active",

      Cell: (cell: CellInfo) => {
        return (
          <div style={{ textAlign: "center" }}>
            <Checkbox
              checked={cell.original.isActive}
              onChange={(e: any, value: any) => {
                console.log("cell: ", cell);
                let idx = (props.profileDivision?.data || []).findIndex(
                  (data: any) => data.id === selectedSettingDivisionsHasUser?.id
                );
                if (idx !== -1) {
                  console.log("props.profileDivision?.data: ", props.profileDivision?.data);
                  let adminMenuList =
                    props.profileDivision?.data?.[idx]?.extra?.adminMenuList || [];
                  if (value.checked) {
                    if (!adminMenuList.includes(cell.original.menuName)) {
                      adminMenuList.push(cell.original.menuName);
                    }
                  } else {
                    adminMenuList = adminMenuList.filter((i: any) => i !== cell.original.menuName);
                  }
                  props.setProp(`profileDivision.data.${idx}.extra.adminMenuList`, adminMenuList);
                }
              }}
            />
          </div>
        );
      },
    },
  ];
  // console.log("CardSettingDivision adminScreenColumns: ", adminScreenColumns);
  // console.log(
  //   "CardSettingDivision props.controller.data.masterData: ",
  //   props.controller.data.masterData
  // );

  return (
    <div style={{ overflow: "scroll", height: "90%" }}>
      <SnackMessage
        onEvent={props.onEvent}
        error={props.errorMessage?.[CARD_SETTING_DIVIDION]?.error}
        success={null}
        onClose={() => {
          props.setProp(`errorMessage.${CARD_SETTING_DIVIDION}`, null);
        }}
        languageUX={props.languageUX}
      />

      <CardSettingDivisionUX
        // data
        dataDivision={dataDivision}
        headers={props.tableHeaders}
        keys={props.tableKeys}
        titleAddDivision={titleAddDivision}
        showTable
        // callback
        getTdProps={handleGetTdProps}
        getTrProps={handleGetTrProps}
        onCancel={handleCancel}
        onOpenDivision={handleOpenDivision}
        divider={selectedSettingDivisionsHasUser?.name ? <Divider /> : null}
        titleTableAdminScreen={
          selectedSettingDivisionsHasUser?.name
            ? `กำหนดรายการเมนู Admin ของแผนก ${selectedSettingDivisionsHasUser?.name}`
            : ""
        }
        tableAdminScreen={
          selectedSettingDivisionsHasUser?.id ? (
            <ReactTable
              data={dataScreen}
              columns={adminScreenColumns}
              showPagination={false}
              pageSize={dataScreen?.length}
              style={{ height: "400px", width: "50%" }}
            />
          ) : null
        }
        // Element
        buttonSave={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            // config
            color={props.profileDivision?.raw.length ? "yellow" : "green"}
            disabled={!(props.profileDivision?.data.length || props.profileDivision?.raw.length)}
            name="SAVE"
            // data
            paramKey={`${CARD_SETTING_DIVIDION}_SAVE`}
            size="small"
            style={{ width: "100%" }}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_SETTING_DIVIDION}_SAVE`]}
            onClick={handleSave}
            title={
              props.profileDivision?.raw.length
                ? intl.formatMessage({ id: "key805", defaultMessage: "บันทึกการแก้ไข" })
                : intl.formatMessage({ id: "key180", defaultMessage: "บันทึก" })
            }
          />
        }
        languageUX={props.languageUX}
      />

      <ModSelectDivision
        open={openDivision}
        organizationFilter
        divisionOptions={divisionsNotInclude}
        onClose={() => {
          setOpenDivision(false);
        }}
        onSelect={handleSelect}
        languageUX={props.languageUX}
      />

      <Modal
        open={openAddExtra}
        onClose={() => {
          setOpenAddExtra(false);
        }}
      >
        <>
          <div style={styles.header}>
            <div style={styles.title}>{intl.formatMessage({ id: "เลือกสิทธิ์การใช้งาน" })}</div>
          </div>

          {["แก้ไขระดับราคาและส่วนลดค่าบริการ"].map((value) => (
            <div key={`Radio-${value}`}>
              <Checkbox
                checked={selectedExtra.includes(value)}
                label={value}
                name={value}
                style={{ margin: "10px" }}
                onChange={handleChangeRight}
              />
            </div>
          ))}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "20px",
            }}
          >
            <Button color="green" style={{ marginRight: "20px" }} onClick={handleSaveRight}>
              บันทึก
            </Button>
            <Button
              color="red"
              style={{ marginRight: "20px" }}
              onClick={() => {
                setOpenAddExtra(false);
              }}
            >
              ยกเลิก
            </Button>
          </div>
        </>
      </Modal>

      <ModConfirmCNMI
        denyButtonColor="red"
        denyButtonText={intl.formatMessage({ id: "ยกเลิก" })}
        openModal={!!modConfirmDelete}
        size="mini"
        titleColor="red"
        onCloseWithDimmerClick={handleCloseModConfirmDelete}
        onDeny={handleCloseModConfirmDelete}
        approveButton={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            // config
            color={"green"}
            name="DELETE"
            // data
            paramKey={`${CARD_SETTING_DIVIDION}_DELETE`}
            size="medium"
            style={{ width: "100%" }}
            title={intl.formatMessage({ id: "ตกลง" })}
            basic
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_SETTING_DIVIDION}_DELETE`]}
            onClick={handleConfirmDelete}
          />
        }
        content={
          <div
            style={{
              fontWeight: "bold",
              margin: "0rem 0 -1rem",
              textAlign: "center",
            }}
          >
            ต้องการลบข้อมูลหรือไม่
          </div>
        }
      />

      <ModInfo
        open={!!modInfo}
        titleColor={modInfo?.color}
        titleName={modInfo?.msg}
        onApprove={handleCloseModInfo}
        onClose={handleCloseModInfo}
      />
    </div>
  );
};

export const ADMIN_NAME_LIST = Object.freeze({
  ตั้งค่าแพ็กเกจ: "ตั้งค่าแพ็กเกจ",
  "Setting Package Lab": "Setting Package Lab",
  "สร้าง Official Account": "สร้าง Official Account",
  ข้อมูลส่วนตัว: "ข้อมูลส่วนตัว",
  ตั้งค่าเอกสารยินยอม: "ตั้งค่าเอกสารยินยอม",
  ตั้งค่าชุดทางเลือกการรักษา: "ตั้งค่าชุดทางเลือกการรักษา",
  "ตั้งค่า Official Account": "ตั้งค่า Official Account",
  จัดการสิทธิ์: "จัดการสิทธิ์",
  ตั้งค่าแจ้งเตือนเรียกคิว: "ตั้งค่าแจ้งเตือนเรียกคิว",
  ตั้งค่าแจ้งเตือนนัดหมาย: "ตั้งค่าแจ้งเตือนนัดหมาย",
  ลงตารางแพทย์: "ลงตารางแพทย์",
  บริหารเก้าอี้: "บริหารเก้าอี้",
  ลงตารางเภสัช: "ลงตารางเภสัช",
  สร้างตารางคลินิก: "สร้างตารางคลินิก",
  ตั้งค่าวันหยุด: "ตั้งค่าวันหยุด",
  ข้อมูลสถิติ: "ข้อมูลสถิติ",
  ข้อมูลบุคลากร: "ข้อมูลบุคลากร",
  Studio: "Studio",
  VaccineUpload: "VaccineUpload",
  "Upload ข้อมูลผู้ใช้สิทธิ": "Upload ข้อมูลผู้ใช้สิทธิ",
  ตั้งค่ากฏการเบิก: "ตั้งค่ากฏการเบิก",
  รับชำระเงินต้นสังกัด: "รับชำระเงินต้นสังกัด",
  รายงานทางการเงิน: "รายงานทางการเงิน",
  รายงานประจำคลินิก: "รายงานประจำคลินิก",
  "ออกใบแจ้งหนี้ / ตั้งงวด": "ออกใบแจ้งหนี้ / ตั้งงวด",
  "เตรียมข้อมูล E-Claim": "เตรียมข้อมูล E-Claim",
  "AIPN Send Claim": "AIPN Send Claim",
  บันทึกไฟล์ตอบกลับ: "บันทึกไฟล์ตอบกลับ",
  "import ค่า Lab สำหรับคำนวณรายได้แพทย์": "import ค่า Lab สำหรับคำนวณรายได้แพทย์",
  พิมพ์เอกสารภาษี: "พิมพ์เอกสารภาษี",
  สรุปค่าตอบแทนแพทย์: "สรุปค่าตอบแทนแพทย์",
  ศูนย์ต้นทุนรายใบเสร็จ: "ศูนย์ต้นทุนรายใบเสร็จ",
  รายงานบัญชี: "รายงานบัญชี",
  "OPD Claim Resolve": "OPD Claim Resolve",
  "OPD AR Transaction": "OPD AR Transaction",
  "OPD รายการที่สร้างเลขงวดแล้ว": "OPD รายการที่สร้างเลขงวดแล้ว",
  "OPD Send Claim": "OPD Send Claim",
  "IPD AR Transaction": "IPD AR Transaction",
  "IPD Send Claim Info": "IPD Send Claim Info",
  "IPD Send Claim Result": "IPD Send Claim Result",
  จัดการตารางห้องผ่าตัด: "จัดการตารางห้องผ่าตัด",
  "Anesthesia Template": "Anesthesia Template",
  "Segment tool": "Segment tool",
  Debug: "Debug",
  ตรวจสอบรายการสินค้าและบริการ: "ตรวจสอบรายการสินค้าและบริการ",
  "Upload by template": "Upload by template",
  "Printer list": "Printer list",
  "PdfMake Header Preview": "PdfMake Header Preview",
  "Order Set Template": "Order Set Template",
  "Trigger/Resend BillingPYINF": "Trigger/Resend BillingPYINF",
  "Trigger/Resend DischargeINF": "Trigger/Resend DischargeINF",
  "Trigger/Resend DrugTransferINF": "Trigger/Resend DrugTransferINF",
  "Trigger/Resend DrugDispensingINF": "Trigger/Resend DrugDispensingINF",
  "Trigger Operating Order (DFINF)": "Trigger Operating Order (DFINF)",
  "Trigger DoctorFee Order (DFINF)": "Trigger DoctorFee Order (DFINF)",
  "Trigger Lab Order (DFINF)": "Trigger Lab Order (DFINF)",
  "Trigger Imaging Order (DFINF)": "Trigger Imaging Order (DFINF)",
  "Trigger/Resend BillingBLINF": "Trigger/Resend BillingBLINF",
  "เครื่องมือกายภาพบำบัดและ Slot เวลา": "เครื่องมือกายภาพบำบัดและ Slot เวลา",
  "Trigger Treatment Order (DFINF)": "Trigger Treatment Order (DFINF)",
  "Trigger/Resend DFINF": "Trigger/Resend DFINF",
  "Trigger Invoiceitem (BillingINF)": "Trigger Invoiceitem (BillingINF)",
  "Trigger/Resend PatientRecordINF": "Trigger/Resend PatientRecordINF",
  "Generate Outbound (By Freeze Time)": "Generate Outbound (By Freeze Time)",
  "Generate Drug Continue (By Date)": "Generate Drug Continue (By Date)",
  "Generate Drug Continue (Plan Item)": "Generate Drug Continue (Plan Item)",
  "Edit Division Supply Order": "Edit Division Supply Order",
  "Add NED To Drug Order Item": "Add NED To Drug Order Item",
  "Training System": "Training System",
  "Work Schedule": "Work Schedule",
  "Self Service & Time Schedule": "Self Service & Time Schedule",
  Payroll: "Payroll",
  "Leave Policy": "Leave Policy",
  MeForm: "MeForm",
  MeCast: "MeCast",
  Target: "Target",
  "Work & Plan System": "Work & Plan System",
  แชท: "แชท",
  สรุปนัดหมาย: "สรุปนัดหมาย",
  "คำขอเป็นสมาชิกนักกายภาพ MeHealth": "คำขอเป็นสมาชิกนักกายภาพ MeHealth",
  "รายชื่อนักกายภาพผู้ให้บริการใน MeHealth": "รายชื่อนักกายภาพผู้ให้บริการใน MeHealth",
  "รายชื่อสมาชิก OA": "รายชื่อสมาชิก OA",
  หลักฐานการชำระเงิน: "หลักฐานการชำระเงิน",
  "Billing & Package": "Billing & Package",
  เวลาเปิดให้บริการ: "เวลาเปิดให้บริการ",
  ตารางผู้ให้บริการ: "ตารางผู้ให้บริการ",
  MeWeb: "MeWeb", // rename from CMS -> MeWeb
  "ทำนัดหมาย": "ทำนัดหมาย",
  "รายชื่อผู้นัดหมาย": "รายชื่อผู้นัดหมาย",
  "Affiliate": "Affiliate",
  "MePOS": "MePOS", // rename รายชื่อผู้รับบริการ -> MePOS
  "รายการบริการ": "รายการบริการ",
  "MeChart": "MeChart",
  "IsChart": "IsChart",
  "AdminIsChart": "AdminIsChart",
  "MeGen": "MeGen",
  "MeGenCost": "MeGenCost",
  "MeERP": "MeERP",
  "MeScript": "MeScript",
  "GenQRcode": "GenQRcode",
  "MeCRM": "MeCRM",
  "MePOSCRM": "MePOSCRM",
  "รายงานการใช้สิทธิ": "รายงานการใช้สิทธิ",
  "สิทธิการเข้าถึง Official Account": "สิทธิการเข้าถึง Official Account",
  "จัดการพนักงาน": "จัดการพนักงาน",
});

export const ADMIN_TAB_LIST = Object.freeze({
  // Employee List
  "Division/Special permission": "Division/Special permission",
  "Employee Document": "Employee Document",
  "Employee info history": "Employee info history",
  "Employee Information": "Employee Information",
  "Employee payment detail": "Employee payment detail",
  // Work Schedule
  "Employee Attendance": "Employee Attendance",
  "Employee Leave Request": "Employee Leave Request",
  "Employee Training": "Employee Training",
  "Set up Work Schedule": "Set up Work Schedule",
  "Set up Work Shift template": "Set up Work Shift template",
  "Summary Work Hour/Month": "Summary Work Hour/Month",
  "Training Management": "Training Management",
  // Self service & Time Schedule
  "Leave History": "Leave History",
  "My shift schedule": "My shift schedule",
  PaySlip: "PaySlip",
  "Time Attendance": "Time Attendance",
  "Training History": "Training History",
  "Work hour per month": "Work hour per month",
  // Work & Plan
  "Issue list": "Issue list",
  "Project list": "Project list",
  // Training system
  "Course List": "Course List",
  "Summary Training KPI": "Summary Training KPI",
  "Training KPI Setting": "Training KPI Setting",
  "Training Schedule": "Training Schedule",
  // Pay roll
  "Revenue & Deduct": "Revenue & Deduct",
  Salary: "Salary",
  "Setting": "Setting",
});

export const ADMIN_ICON_LIST: Record<string, string> =
  CONFIG.COMPANY === "MEHEALTH"
    ? {
      [ADMIN_NAME_LIST.Studio]: "/static/images/menus/diag-studio.png",
      [ADMIN_NAME_LIST.Target]: "/static/images/menus/target.png",
      [ADMIN_NAME_LIST["ข้อมูลส่วนตัว"]]: "/static/images/menus/user-profile.png",
      [ADMIN_NAME_LIST["จัดการสิทธิ์"]]: "/static/images/menus/permission-management.png",
      [ADMIN_NAME_LIST["แชท"]]: "/static/images/menus/admin-chat.png",
      [ADMIN_NAME_LIST["ตั้งค่า Official Account"]]: "/static/images/menus/setting-oa.png",
      [ADMIN_NAME_LIST["สร้าง Official Account"]]: "/static/images/menus/create-oa.png",
      [ADMIN_NAME_LIST["Billing & Package"]]: "/static/images/menus/setting-oa.png",
      [ADMIN_NAME_LIST["ตั้งค่าแจ้งเตือนนัดหมาย"]]: "/static/images/menus/appointment-reminder.svg",
      [ADMIN_NAME_LIST["ลงตารางแพทย์"]]: "/static/images/menus/telemed.png",
      [ADMIN_NAME_LIST["สร้างตารางคลินิก"]]: "/static/images/menus/queue.png",
      [ADMIN_NAME_LIST["ตั้งค่าวันหยุด"]]: "/static/images/menus/ep_monitor.png",
      [ADMIN_NAME_LIST["เวลาเปิดให้บริการ"]]: "/static/images/menus/queue.png",
      [ADMIN_NAME_LIST["ตารางผู้ให้บริการ"]]: "/static/images/menus/telemed.png",
      [ADMIN_NAME_LIST["หลักฐานการชำระเงิน"]]: "/static/images/menus/report.png",
      [ADMIN_NAME_LIST["ข้อมูลบุคลากร"]]: "/static/images/menus/staff-chat.png",
      [ADMIN_NAME_LIST.MeForm]: "/static/images/menus/diag-studio.png",
      [ADMIN_NAME_LIST.MeCast]: "/static/images/menus/telemed.png",
      [ADMIN_NAME_LIST["สรุปนัดหมาย"]]: "/static/images/menus/report.png",
      [ADMIN_NAME_LIST["ทำนัดหมาย"]]: "/static/images/menus/appointment-add.svg",
      [ADMIN_NAME_LIST["รายชื่อผู้นัดหมาย"]]: "/static/images/menus/appointment-person.svg",
      [ADMIN_NAME_LIST.Affiliate]: "/static/images/menus/report.png",
      [ADMIN_NAME_LIST.MePOS]: "/static/images/menus/staff-chat.png",
      [ADMIN_NAME_LIST["คำขอเป็นสมาชิกนักกายภาพ MeHealth"]]: "/static/images/menus/physio-member-request.svg",
      [ADMIN_NAME_LIST["รายชื่อนักกายภาพผู้ให้บริการใน MeHealth"]]: "/static/images/menus/physio-provider-list.svg",
      [ADMIN_NAME_LIST["รายชื่อสมาชิก OA"]]: "/static/images/menus/oa-member-list.svg",
      [ADMIN_NAME_LIST["รายการบริการ"]]: "/static/images/menus/service-list.svg",
      [ADMIN_NAME_LIST.MeWeb]: "/static/images/menus/me-web.svg",
      [ADMIN_NAME_LIST.MeScript]: "/static/images/menus/me-script.svg",
      [ADMIN_NAME_LIST.MeGen]: "/static/images/menus/me-gen.svg",
      [ADMIN_NAME_LIST.MeGenCost]: "/static/images/menus/me-gen.svg",
      [ADMIN_NAME_LIST.MeERP]: "/static/images/menus/report.png",
      [ADMIN_NAME_LIST.IsChart]: "/static/images/menus/ischart.svg",
      [ADMIN_NAME_LIST.MeChart]: "/static/images/menus/mechart.svg",
      [ADMIN_NAME_LIST.GenQRcode]: "/static/images/menus/me-gen.svg",
      [ADMIN_NAME_LIST.MeCRM]: "/static/images/menus/me-crm.svg",
    }
    : {};

export const ADMIN_LABEL_LIST: Record<string, string> =
  CONFIG.COMPANY === "MEHEALTH"
    ? {
      [ADMIN_NAME_LIST.Studio]: "Diag Studio",
    }
    : ADMIN_NAME_LIST;

export const MOBILE_MENU_LIST = {
  Chat: "Chat",
  Schedule: "Schedule",
  // Broadcast
  Broadcast: "Broadcast",
};

export default React.memo(CardSettingDivision);
